import React, { useEffect, useState } from 'react';
import { Sticky } from 'react-sticky';
import styles from './styles.module.styl';

const Sidebar = () => {
  const [activeLink, setActiveLink] = useState(null);
  // sectionAnchors in reverse order
  const sectionAnchors = ['lock', 'mgmt', 'native', 'backend', 'webapp', 'spa'];

  useEffect(() => {
    const onScroll = () => {
      const currentScrollHeight = window.pageYOffset;
      const top = $('.docs-content-container').scrollTop() + $('header').outerHeight();

      const active = sectionAnchors.find((anchor) => {
        const offset = $(`#${anchor}`).offset();
        return currentScrollHeight > (offset.top - top);
      });
      setActiveLink(active);
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Sticky>
      {({ isSticky, style }) => (
        <div style={style} className={isSticky ? styles.sticky : ''}>
          <div className={`${styles.sectionTitle}`}>Libraries</div>
          <ul className={styles.listStyleNone}>
            <li className={styles.sectionitem}>
              <a href="#spa" className={`${styles.sectionLink} ${activeLink === 'spa' && styles.activeLink}`}>
                Single-page app libraries
              </a>
            </li>
            <li className={styles.sectionitem}>
              <a href="#webapp" className={`${styles.sectionLink} ${activeLink === 'webapp' && styles.activeLink}`}>
                Regular web app libraries
              </a>
            </li>
            <li className={styles.sectionitem}>
              <a href="#backend" className={`${styles.sectionLink} ${activeLink === 'backend' && styles.activeLink}`}>
                Back-end / API libraries
              </a>
            </li>
            <li className={styles.sectionitem}>
              <a href="#native" className={`${styles.sectionLink} ${activeLink === 'native' && styles.activeLink}`}>
                Native / mobile libraries
              </a>
            </li>
            <li className={styles.sectionitem}>
              <a href="#mgmt" className={`${styles.sectionLink} ${activeLink === 'mgmt' && styles.activeLink}`}>
                Management API SDK libraries
              </a>
            </li>
            <li className={styles.sectionitem}>
              <a href="#lock" className={`${styles.sectionLink} ${activeLink === 'lock' && styles.activeLink}`}>
                Auth0 Lock SDK libraries
              </a>
            </li>
          </ul>
        </div>
      )}
    </Sticky>);
};

export default Sidebar;
